import React from 'react';
// Icons
import { Icons } from '@ems/client-design-system';
// screens
import { Operations, OperationsSummary } from './operations';
import { Reports } from './reports';
import { Settings } from './settings';
import { ComingSoon } from './comingSoon';
import {
  Infringements,
  InfringementsSummary,
  InfringementsCandidates,
  InfringementsATC,
} from './infringements';
import { NoiseEvents, NoiseEventsSummary } from './noiseEvents';

const overviewIcon = <Icons iconName="ic-overview" className="ic-overview" size="20" />;
const operationsIcon = <Icons iconName="ic-operations" className="ic-operations" size="20" />;
const noiseIcon = <Icons iconName="ic-noise" className="ic-noise" size="20" />;
const infringementsIcon = (
  <Icons iconName="ic-infringements" className="ic-infringements" size="20" />
);
const reportsIcon = <Icons iconName="ic-reports" className="ic-reports" size="20" />;
const complaintsIcon = <Icons iconName="ic-complaints" className="ic-complaints" size="20" />;
const settingsIcon = <Icons iconName="ic-settings" className="ic-settings" size="20" />;

// 1. Pages with NotFound are not done yet, but are needed for NavBar purposes
export const routes = [
  {
    route: 'overview',
    icon: overviewIcon,
    navBarPosition: 'header',
    component: ComingSoon,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'operations/:id',
    component: OperationsSummary,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'infringements/:id',
    component: InfringementsSummary,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'noiseevents/:id',
    component: NoiseEventsSummary,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'operations',
    icon: operationsIcon,
    navBarPosition: 'header',
    component: Operations,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'noiseevents',
    icon: noiseIcon,
    navBarPosition: 'header',
    component: NoiseEvents,
    permissions: [{ name: 'NoiseEventSummary', type: ['Read'] }],
  },
  {
    route: 'infringements',
    icon: infringementsIcon,
    navBarPosition: 'header',
    component: Infringements,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'infringements-candidates',
    icon: infringementsIcon,
    component: InfringementsCandidates,
    navBarPosition: 'header',
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'infringements-atc',
    component: InfringementsATC,
    navBarPosition: 'header',
    icon: infringementsIcon,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'complaints',
    icon: complaintsIcon,
    navBarPosition: 'header',
    component: ComingSoon,
    permissions: [
      { name: 'Complainer', type: ['Read'] },
      { name: 'ComplaintSummary', type: ['Read'] },
    ],
  },
  {
    route: 'reports',
    icon: reportsIcon,
    navBarPosition: 'header',
    component: Reports,
    permissions: [
      { name: 'Operation', type: ['Read'] },
      { name: 'OperationSummary', type: ['Read'] },
    ],
  },
  {
    route: 'settings',
    icon: settingsIcon,
    navBarPosition: 'footer',
    component: Settings,
    permissions: [
      { name: 'Complainer', type: ['Read'] },
      { name: 'ComplaintSummary', type: ['Read'] },
    ],
  },
];
